//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import cfr from './cfrList'
    export default{
        name:'christmas_form_three',
        components: {
            cfr
        },
        data(){
            return{
                get_host:host.host,
                list_id:'',
                showCfrList:false,
                cfrText:'',
                form:{
                    room:'',
                    momName:'',
                    delivery_type:'',
                    record_date:'',
                    record_hour:'',
                    detail:'',
                    agent_id:'',
                    agent_sign:'',
                    shifts:''
                },
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        created(){
            this.apiMemberInfo()
            if(this.$route.query.list_id){
                this.apiDetail()
            }
        },
        methods:{
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                        this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : ''
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
             //点击选择查房人
            selectPeople(){
                this.showCfrList = true
            },
            //赋值查房人ID
            cfrListEven(val,item){
                this.showCfrList = val
                if(item){
                    this.form.agent_id = item.id
                    this.cfrText = item.user_name
                }
            },
            save(){
                let signature ='signature1'
                let png = this.$refs[signature].save()
                this.form.agent_sign = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.agent_sign = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.agent_sign = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.getMatarnalSpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room
                        this.form.delivery_type = data.delivery_type
                        this.form.record_date=data.record_date,
                        this.form.record_hour=data.record_hour,
                        this.form.detail=data.detail,
                        this.form.agent_id=data.agent_id,
                        this.form.agent_sign=data.agent_sign.indexOf(this.get_host) != -1 ? data.agent_sign : this.get_host+data.agent_sign
                        this.form.shifts=data.shifts
                        this.showSignature = true
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    delivery_type:this.form.delivery_type,
                    record_date:this.form.record_date,
                    record_hour:this.form.record_hour,
                    detail:this.form.detail,
                    agent_id:this.form.agent_id,
                    agent_sign:this.form.agent_sign,
                    shifts:this.form.shifts
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.addMatarnalSpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_three',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求更新数据
            apiUpdateForm(){
                let params = {
                    id:this.$route.query.list_id,
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    delivery_type:this.form.delivery_type,
                    record_date:this.form.record_date,
                    record_hour:this.form.record_hour,
                    detail:this.form.detail,
                    agent_id:this.form.agent_id,
                    agent_sign:this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host,'') : this.form.agent_sign,
                    shifts:this.form.shifts
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.updateMatarnalSpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_three',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_three.vue